<template>
  <div>
    <div class="bannerStyle">
      <img src="@/assets/bannera.jpg" />
      <img src="@/assets/bannerb.jpg" />
      <img src="@/assets/bannerc.jpg" />
    </div>
    <div class="bodyBox">
      <div class="floatLeft boxLeft">
        <p class="boxp1"><img src="@/assets/jtjs.jpg" /></p>
        <p class="boxp2">
          “德心合”集团坚持以人为本的服务理念，致力于深入研究和解决人体所处的“第三状态”（Sub-health
          condition），即常被界定为的亚健康状态。我们的团队汇集了一流的专家，利用前沿的科学研究方法，为人们在日常生活中遇到的身体和心理健康问题提供专业解决方案。</p>
        <a href="javascript:;" @click="handel(1)" class="groupHref">更多</a>
        <p class="boxp3"><img src="@/assets/zz.jpg" /></p>
      </div>
      <div class="floatRight textOverView">
        <div class="leftArrow">
          <img src="@/assets/left.png" style="width:100%;" @click="arrowClick('left')" />
        </div>
        <el-carousel ref="cardShow" :interval="5000" arrow="never" indicator-position="none">
          <el-carousel-item v-for="(i, idx) in bannerList" :key="idx">
            <img :src="i" style="height:510px;" />
          </el-carousel-item>
        </el-carousel>
        <div class="rightArrow">
          <img src="@/assets/right.png" style="width:100%;" @click="arrowClick('right')" />
        </div>
      </div>
    </div>
    <div><img src="@/assets/center.jpg" style="width:100%;" /></div>
    <div>
      <p class="pbanner"><img src="@/assets/zjtd.jpg" /></p>
      <el-carousel indicator-position="outside" class="bodyDl" arrow="never">
        <el-carousel-item v-for="(item,index) in list" :key="index" style="background:none;">
          <dl>
            <dt class="floatLeft">
              <img :src="item.img" style="width:292px;border-radius:500px;" />
            </dt>
            <dd class="floatRight">
              <p class="dlp1"><b>{{item.title}}</b><span>{{item.label}}</span>
              </p>
              <p class="dlp2" v-if="item.title != '创始人'">
                {{item.text}}
              </p>

              <p class="dlp3" v-else>
                <template v-for="(row,index) in (item.text).split(',')">
                  <span v-html="row"></span>
                </template>
              </p>
              <a class="dlHref" href="javascript:;" @click="expertDetail(item,index)">更多</a>
            </dd>
          </dl>
        </el-carousel-item>
      </el-carousel>

      <div class="expert">
        <dl v-for="(item, index) in imageList" :key="index" @click="hrEfexper(item)">
          <dt><img :src="item.url" /></dt>
          <dd>{{item.name}}</dd>
        </dl>
      </div>
    </div>
    <div class="psychology">
      <div class="psychologyTop">
        <p class="psyp"><img src="@/assets/xlzs.jpg" /></p>
        <dl>
          <dt class="floatLeft">
            <p><img src="@/assets/b1.jpg" /></p>
            <p class="coupe">
              <b>关于抑郁症的科普</b>
              <span>重性抑郁障碍（Major Depressive Disorder,MDD）是一种精神疾病,表现为持续的悲伤、失望和兴趣缺失,并伴有其他症状...</span>
            </p>
          </dt>
          <dd class="floatRight ddRight">
            <p @click="hrefDetail('PTSD&ASD的基础知识、治疗以及创伤后成长')">
              <b>PTSD&ASD的基础知识、治疗以及创伤后成长</b>
              <span>在我们所生活的世界中，个体可能会遭遇各种形式的创伤或极端应激事件，从自然灾害到人为的暴力行为，从突如其来的失落...</span>
            </p>
            <p @click="hrefDetail('失眠:深入理解及其缓解之道')">
              <b>失眠:深入理解及其缓解之道</b>
              <span>失眠，一个大家耳熟能详的词汇，但是你真正了解它吗？失眠，或称为睡眠障 碍，是指在合适的睡眠环境和条件下，个体出现入睡困难...</span>
            </p>
            <p style="margin-bottom:0;" @click="hrefDetail('心中的拉锯战:理解认知解离的根源')">
              <b>心中的拉锯战：理解认知解离的根源</b>
              <span>在繁华的都市背后，每个人的心灵深处都可能藏有一个小小的秘密—— 那些内心 与行为之间的不协调瞬间。你是否曾经觉得...</span>
            </p>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [{
            img: require('@/assets/csr1.jpg'),
            title: "创始人",
            label: "Dr. Sabrina Zhao",
            text: "心理学硕士&emsp;美国内尔研究所（Neill Institute）,管理与心理学博士后研究&emsp;英国剑桥大学(University of Cambridge),心理学硕士&emsp;美国菲尔莱狄更斯大学,工商管理硕士&emsp;法国布雷斯特学院(Brest Business School),注册国际高级心理咨询师（CISPC）: 2341E0077991,积极心理学认证&emsp;清华大学,香港心理协会会员"
          },
          {
            img: require('@/assets/sx.jpg'),
            title: "首席合伙人",
            label: "朱翔坤",
            text: "朱翔坤深受“爱与多元与包容性(D&l)”这一愿景的推动。作为VMC全球咨询公司的创始人，她为奢侈品牌和业界领先的独角兽公司提供咨询、培训和教练辅导服务。她还是InnerSight心理咨询有限公司的合伙人，并且拥有心理学博士学位。作为国际大学的客座讲师，以及艺术治疗师和摄影师，她具有多元的职业背景。让我们一同拥抱使命:通过“爱与多元与包容性”来丰富这个世界。#心理学博士#商业敏捷#人才管理#高净值人才发展。"
          },
        ],
        bannerList: [
          require('@/assets/t1.jpg'),
          require('@/assets/t2.jpg'),
          require('@/assets/t3.jpg')
        ],
        imageList: [{
            name: '郎依',
            url: require('@/assets/rys.jpg')
          },
          {
            name: '王亿雯',
            url: require('@/assets/wyws.jpg')
          },
          {
            name: '张晓菲',
            url: require('@/assets/zxfs.jpg')
          },
          {
            name: '武清云',
            url: require('@/assets/wqys.jpg')
          },
          {
            name: '琳晨',
            url: require('@/assets/lcs.jpg')
          },
        ]
      }
    },
    created() {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > 0) {
        // 如果当前位置不为零，则执行滚动操作
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    },
    methods: {
      arrowClick(val) {
        if (val === 'right') {
          this.$refs.cardShow.next()
        } else {
          this.$refs.cardShow.prev()
        }
      },
      handel(num) {
        this.$emit('customEvent', num);
      },
      expertDetail(item, n) {
        let obj = {
          label: item.label,
          title: item.title
        }
        if (n == 0) {
          obj.label = "趙塰嬿";
          obj.img = require('@/assets/zhy.jpg');
        } else {
          obj.img = require('@/assets/zxk.jpg');
        }
        localStorage.setItem('userJson', JSON.stringify(obj));
        this.$emit('customEvent', 2);
      },
      hrEfexper(item) {
        let obj = {
          label: item.name,
          title: "资深咨询师",
          img: item.url
        }
        localStorage.setItem('userJson', JSON.stringify(obj));
        this.$emit('customEvent', 2);
      },
      hrefDetail(text) {
        localStorage.setItem('userText', JSON.stringify(text));
        this.$emit('customEvent', 3);
      }
    },

  }
</script>

<style scoped>
  .bodyBox {
    margin: 63px auto 0 auto;
    width: 950px;
    display: table;
  }

  .boxLeft {
    width: 317px;
    height: 510px;
  }

  .boxp1 {
    margin-top: 70px;
  }


  .boxp2 {
    margin: 30px 0;
    line-height: 24px;
    height: 24px;
    color: #333;
    font-size: 14px;
    display: table;
  }

  .groupHref {
    background: #23B6B0;
    border-radius: 20px;
    padding: 3px 20px;
    color: #fff;
    font-size: 14px;
  }

  .boxp3 {
    margin-top: 60px;
    text-align: center;
  }

  .boxp3 img {
    width: 220px;
  }

  .pbanner {
    margin-top: 32px;
    text-align: center;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .textOverView {
    width: 565px;
    position: relative;
    margin-bottom: 70px;
  }

  .leftArrow {
    position: absolute;
    width: 23px;
    height: 50px;
    top: 40%;
    left: 36px;
    z-index: 999;
    cursor: pointer;
  }

  .rightArrow {
    position: absolute;
    width: 23px;
    height: 50px;
    right: 36px;
    top: 40%;
    z-index: 999;
    cursor: pointer;
  }

  .textOverView /deep/ .el-carousel__container {
    height: 510px;
  }

  .bodyDl {
    width: 808px;
    margin: 40px auto;
  }

  .bodyDl dt {
    width: 292px;
  }

  .bodyDl dd {
    width: 474px;
    padding-top: 35px;
  }

  .bodyDl .dlp1 b {
    font-size: 16px;
    color: #555;
  }

  .bodyDl .dlp1 span {
    font-size: 16px;
    color: #555;
    font-weight: bold;
    padding-left: 26px;
  }

  .bodyDl .dlp2 {
    padding: 18px 0;
    color: #555;
    line-height: 24px;
    font-size: 14px;
  }

  .bodyDl .dlp3 {
    padding: 20px 0;
  }

  .bodyDl .dlp3 span {
    display: block;
    font-size: 14px;
    line-height: 24px;
  }

  .bodyDl .dlHref {
    background: #23B6B0;
    border-radius: 20px;
    padding: 3px 20px;
    font-size: 14px;
    color: #fff;
  }

  .expert {
    display: flex;
    width: 800px;
    margin: 0 auto;
  }

  .expert dl {
    cursor: pointer;
    width: 20%;
    text-align: center;
    padding-bottom: 27px;
  }

  .expert dl dt img {
    width: 139px;
  }

  .expert dl dd {
    color: #555;
    padding: 15px 0;
    font-size: 14px;
  }

  .ddRight {
    width: 445px;
  }

  .ddRight p {
    cursor: pointer;
    padding: 25px 5% 16px 5%;
    width: 90%;
    border: 1px solid #959595;
    margin-bottom: 30px;
  }

  .ddRight p b {
    font-size: 14px;
    display: block;
  }

  .ddRight p span {
    display: block;
    padding-top: 12px;
    line-height: 22px;
    font-size: 13px;
  }

  .psychology {
    background: #F3F3F3;
    padding-bottom: 100px;
  }

  .psychologyTop {
    width: 950px;
    margin: 0 auto;
    display: table;
  }
  .psychologyTop .floatLeft img{width:100%;display:block;}

  .psychologyTop .psyp {
    padding: 42px 0 55px 0;
  }

  .psychologyTop dt {
    width: 426px;
  }

  .psychologyTop .coupe {
    background: #C01921;
    color: #fff;
    padding: 15px 3% 10px 3%;
    width: 94%;
  }

  .psychologyTop .coupe b {
    font-size: 16px;
    display: block;
  }

  .psychologyTop .coupe span {
    display: block;
    padding: 10px 0;
    line-height: 22px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/vbody.vue